export default __webpack_public_path__ + "static/media/Vannamei shrimp feed 2.b9a0e90c.jpg";